export const isKling = name => /^kling(?:[-/.]|$)/i.test(name || '');
export const KLING_RESOLUTIONS = ['720p', '1080p', '2k', '4k'];
export const KLING_MODES = ['t2v', 'i2v', 'firstlast', 'smart_multiframe', 'full_reference'];
export const KLING_AUDIO = ['without_audio', 'with_audio', 'unified'];

// The supplied quote only contains the complete text-to-video section.
const suppliedQuote = [
  ['720p', 'without_audio', .366643, .401016], ['720p', 'with_audio', .672179, .735196],
  ['1080p', 'without_audio', .488857, .534688], ['1080p', 'with_audio', .855500, .935704],
  ['2k', 'without_audio', .611072, .668360], ['2k', 'with_audio', 1.091200, 1.193500],
  ['4k', 'unified', 1.833216, 2.005080],
];
export function klingQuoteDraft() {
  return suppliedQuote.map(([resolution, audio, cost, price]) => ({mode:'t2v', resolution, audio, cost, price}));
}
export function validateKlingPrices(rows) {
  const keys = new Set();
  for (const row of rows || []) {
    if (!KLING_MODES.includes(row.mode) || !KLING_RESOLUTIONS.includes(row.resolution) || !KLING_AUDIO.includes(row.audio)) throw new Error('请选择生成模式、分辨率和音轨');
    if (![row.cost, row.price].every(v => Number.isFinite(v) && v > 0)) throw new Error('成本与售价必须大于 0');
    const key = `${row.mode}/${row.resolution}/${row.audio}`;
    if (keys.has(key)) throw new Error('同一模式、分辨率、音轨不能重复配置');
    keys.add(key);
  }
  for (const row of rows || []) {
    if (row.audio === 'unified' && (rows || []).some(other => other !== row && other.mode === row.mode && other.resolution === row.resolution)) throw new Error('统一音轨价格不能与有音轨、无音轨价格混用');
  }
  return rows || [];
}
export function saveKlingPricing(config, rows) {
  return {...config, kling_pricing: {...config.kling_pricing, version:1, unit:'cny_per_second', rows:validateKlingPrices(rows).map(row => ({mode:row.mode,resolution:row.resolution,audio:row.audio,cost:row.cost,price:row.price}))}};
}
